import { useEffect, useRef, useState } from 'react';
import { setSoundMuted, soundMuted } from './player';

export function PortfolioThemeControl() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(() => soundMuted());
  const [reduced, setReduced] = useState(false);
  const [status, setStatus] = useState('재생하지 않음');

  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const apply = () => {
      setReduced(preference.matches);
      if (preference.matches) {
        audioRef.current?.pause();
        setPlaying(false);
        setStatus('감각 자극 줄이기 설정으로 재생 중지');
      }
    };
    apply();
    preference.addEventListener('change', apply);
    return () => {
      preference.removeEventListener('change', apply);
      audioRef.current?.pause();
    };
  }, []);

  async function togglePlaying() {
    const audio = audioRef.current;
    if (!audio || reduced) return;
    if (!audio.paused) {
      audio.pause();
      setPlaying(false);
      setStatus('일시정지됨');
      return;
    }
    try {
      await audio.play();
      setPlaying(true);
      setStatus('여행 준비 음악 재생 중');
    } catch {
      setPlaying(false);
      setStatus('재생할 수 없음');
    }
  }

  function toggleMuted() {
    const next = !muted;
    setMuted(next);
    setSoundMuted(next);
    if (audioRef.current) audioRef.current.muted = next;
    setStatus(next ? '음소거됨' : playing ? '여행 준비 음악 재생 중' : '소리 켜짐 · 재생하지 않음');
  }

  return <section className="portfolio-theme-control" aria-labelledby="portfolio-theme-title">
    <div><span className="eyebrow">여행 준비 리듬</span><h3 id="portfolio-theme-title">준비 현황을 보며 잠깐 들어보세요.</h3><p>음악 없이도 모든 현황과 다음 행동을 그대로 확인할 수 있어요.</p></div>
    <div className="portfolio-theme-actions">
      <button type="button" className="button secondary" onClick={() => void togglePlaying()} disabled={reduced}>{playing ? '일시정지' : '음악 재생'}</button>
      <button type="button" className="button secondary" onClick={toggleMuted} aria-pressed={muted} disabled={reduced}>{muted ? '소리 켜기' : '음소거'}</button>
    </div>
    <p className="portfolio-theme-status" role="status" aria-live="polite">{reduced ? '감각 자극 줄이기 설정에서 음악을 사용하지 않아요.' : status}</p>
    <audio ref={audioRef} src="/audio/portfolio-theme.mp3" preload="none" loop muted={muted} onEnded={() => { setPlaying(false); setStatus('재생 종료'); }} />
  </section>;
}
